import { apiSlice } from "../../app/api/apiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => {
    return ({
      resetPassword: builder.mutation({
        query: (credentials) => ({
          url: '/Account/reset-password',
          method: 'POST',
          responseHandler: 'text',
          //body: { ...credentials }
          body: {
            email: credentials.email,
            password: credentials.password,
            token: credentials.token,
          }
          //body:  JSON.stringify(credentials) 
        })
      }),

      forgotPassword: builder.mutation({
        query: (credentials) => ({
          url: `Account/forgot-password/${credentials?.email}`,
          method: 'POST',
          responseHandler: 'text',
        })
      }),

      login: builder.mutation({
        query: (credentials) => ({
          url: '/Account/login',
          method: 'POST',
          responseHandler: 'text',
          //body: { ...credentials }
          body: {
            email: credentials.email,
            password: credentials.password,
          }
          //body:  JSON.stringify(credentials) 
        })
      }),

      refreshToken: builder.mutation({
        query: (refreshToken) => ({
          url: `/Account/refresh-token`,
          method: 'POST',
          responseHandler: 'text',
          body: {
            token: refreshToken,
          }
        })
      }),

      register: builder.mutation({
        query: (credentials) => ({
          url: 'Account/register',
          method: 'POST',
          responseHandler: 'text',
          body: {
            email: credentials?.email,
            password: credentials?.password
          }
        })
      }),

      changePassword: builder.mutation({
        query: (credentials) => ({
          url: 'Account/change-password',
          method: 'POST',
          responseHandler: 'text',
          body: {
            // email: credentials?.email,
            currentPassword: credentials.currentPassword,
            newPassword: credentials.newPassword
          }
        })
      }),
      getUserDropdownList: builder.query<any, void>({
        query: () => "Account/dropdownList"
      }),
    });
  },
});

export const {
  useResetPasswordMutation,
  useForgotPasswordMutation,
  useLoginMutation,
  useRefreshTokenMutation,
  useRegisterMutation,
  useChangePasswordMutation,
  useLazyGetUserDropdownListQuery
} = authApiSlice;
